export default __webpack_public_path__ + "static/media/product14.ffd60e7e.jpg";